export default {
  myCashierTransactions: [],
  myCashierTransaction: {},
  cashier: {},
  cashiers: [],
  usersLastCashiers: [] // ÚLTIMAS POSIÇÕES DOS CAIXAS DE CADA USUÁRIO (USADO EM CONTAS PARA MOSTRAR A POSIÇÃO ATUAL DOS CAIXAS)
}
